import React from 'react';
import Breadcrumb from '../components/Breadcrumb';

const Datenschutz = () => {
  return (
    <div className="bg-white py-12">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <Breadcrumb items={[{ label: 'Datenschutz' }]} />
        
        <h1 className="text-4xl font-bold text-[#0F172A] mb-8">Datenschutzerklärung</h1>
        
        <div className="prose max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">1. Datenschutz auf einen Blick</h2>
            <h3 className="text-xl font-semibold text-[#0F172A] mb-3">Allgemeine Hinweise</h3>
            <p className="text-gray-700 mb-4">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten 
              passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie 
              persönlich identifiziert werden können.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">2. Datenerfassung auf dieser Website</h2>
            <h3 className="text-xl font-semibold text-[#0F172A] mb-3">Wer ist verantwortlich für die Datenerfassung?</h3>
            <p className="text-gray-700 mb-4">
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten 
              können Sie dem Impressum dieser Website entnehmen.
            </p>

            <h3 className="text-xl font-semibold text-[#0F172A] mb-3">Wie erfassen wir Ihre Daten?</h3>
            <p className="text-gray-700 mb-4">
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um 
              Daten handeln, die Sie in ein Kontaktformular eingeben.
            </p>
            <p className="text-gray-700 mb-4">
              Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme 
              erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
            </p>

            <h3 className="text-xl font-semibold text-[#0F172A] mb-3">Wofür nutzen wir Ihre Daten?</h3>
            <p className="text-gray-700 mb-4">
              Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. 
              Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden, sofern Sie hierzu Ihre 
              Einwilligung erteilt haben.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">3. Kontaktformular</h2>
            <p className="text-gray-700 mb-4">
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular 
              inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall 
              von Anschlussfragen bei uns gespeichert.
            </p>
            <p className="text-gray-700 mb-4">
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage 
              mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen 
              erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse 
              an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf 
              Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">4. Server-Log-Dateien</h2>
            <p className="text-gray-700 mb-4">
              Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, 
              die Ihr Browser automatisch an uns übermittelt. Dies sind:
            </p>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-1">
              <li>Browsertyp und Browserversion</li>
              <li>Verwendetes Betriebssystem</li>
              <li>Referrer URL</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>
            <p className="text-gray-700 mb-4">
              Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser 
              Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">5. Cookies & Tracking</h2>
            <p className="text-gray-700 mb-4">
              Diese Website verwendet Cookies und Tracking-Technologien nur nach Ihrer ausdrücklichen Einwilligung. 
              Sie können Ihre Einwilligung jederzeit über die Cookie-Einstellungen widerrufen.
            </p>
            <h3 className="text-xl font-semibold text-[#0F172A] mb-3">Google Analytics</h3>
            <p className="text-gray-700 mb-4">
              Diese Website nutzt Google Analytics nur nach Ihrer Einwilligung. Google Analytics verwendet Cookies, 
              die eine Analyse der Benutzung der Website durch Sie ermöglichen. Die durch den Cookie erzeugten 
              Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den 
              USA übertragen und dort gespeichert.
            </p>
            <h3 className="text-xl font-semibold text-[#0F172A] mb-3">Google Tag Manager</h3>
            <p className="text-gray-700 mb-4">
              Diese Website verwendet den Google Tag Manager nur nach Ihrer Einwilligung. Der Google Tag Manager ist 
              eine Lösung, mit der wir nachzuverfolgende Website-Tags über eine Oberfläche verwalten können.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">6. Ihre Rechte</h2>
            <p className="text-gray-700 mb-4">
              Sie haben jederzeit das Recht:
            </p>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-1">
              <li>Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten zu erhalten (Art. 15 DSGVO)</li>
              <li>Die Berichtigung unrichtiger Daten zu verlangen (Art. 16 DSGVO)</li>
              <li>Die Löschung Ihrer Daten zu verlangen (Art. 17 DSGVO)</li>
              <li>Die Einschränkung der Verarbeitung zu verlangen (Art. 18 DSGVO)</li>
              <li>Der Verarbeitung zu widersprechen (Art. 21 DSGVO)</li>
              <li>Ihre Daten in einem strukturierten Format zu erhalten (Art. 20 DSGVO)</li>
            </ul>
            <p className="text-gray-700 mb-4">
              Zur Ausübung dieser Rechte wenden Sie sich bitte an: 
              <a href="mailto:info@haushaltsaufloesung.services" className="text-[#16A34A] hover:underline"> info@haushaltsaufloesung.services</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">7. Kontakt</h2>
            <p className="text-gray-700">
              Bei Fragen zum Datenschutz wenden Sie sich bitte an:<br />
              <strong>Schössow Dienstleistungen</strong><br />
              Neben dem Brand 10<br />
              44135 Dortmund<br />
              E-Mail: <a href="mailto:info@haushaltsaufloesung.services" className="text-[#16A34A] hover:underline">info@haushaltsaufloesung.services</a><br />
              Telefon: <a href="tel:+4923139085116" className="text-[#16A34A] hover:underline">0231 39085116</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;